import Helper from './Helper.js';

class HashHandler {
  constructor() {
    if ('scrollRestoration' in history) {
      history.scrollRestoration = 'manual';
    }

    setTimeout(() => {
      this.handleDeepLink();
    }, 500);
  }

  getNoteIdFromUrl() {
    const params = new URLSearchParams(window.location.search);
    const note = params.get('note');
    if (!note) return null;

    const n = Number(note);
    if (!Number.isFinite(n) || n <= 0) return null;

    return `note-${n}`;
  }

  getHashIdFromUrl() {
    const raw = window.location.hash;
    if (!raw || raw === '#0') return null;

    return decodeURIComponent(raw.slice(1)).trim() || null;
  }

  handleDeepLink() {
    const noteId = this.getNoteIdFromUrl();
    const hashId = this.getHashIdFromUrl();

    if (!noteId && !hashId) return;

    const originalHash = window.location.hash;
    if (originalHash) {
      history.replaceState(null, '', window.location.pathname + window.location.search);
    }

    let noteEl = null;

    if (noteId) {
      noteEl = document.getElementById(noteId);
      if (noteEl) {
        this.wpAccordion(noteEl);
        this.nsAccordion(noteEl);
      }
    }

    setTimeout(() => {
      let target = null;

      if (hashId) {
        const selector = `#${CSS.escape(hashId)}`;
        target =
          (noteEl && noteEl.querySelector(selector)) ||
          document.querySelector(selector);
      }

      if (!target && noteEl) target = noteEl;
      if (!target) return;

      this.scrollIntoView(target, true);

      this.ensureNotCoveredByHeader(target);

      if (originalHash) {
        history.replaceState(
          null,
          '',
          window.location.pathname + window.location.search + originalHash
        );
      }
    }, 350);
  }

  wpAccordion(anchor) {
    const accordion = anchor.closest('.wp-accordion');
    if (!accordion) return;

    const accordionHeader = accordion.querySelector('.wp-accordion__head');
    if (accordionHeader && !accordionHeader.classList.contains('active')) {
      accordionHeader.click();
    }
  }

  nsAccordion(anchor) {
    const accordion = anchor.closest('.ns-accordion');
    if (!accordion) return;

    const toggle =
      accordion.querySelector('.ns-accordion__head, .ns-accordion__header, [data-accordion-toggle]');

    if (toggle) {
      const isActive = accordion.classList.contains('active') || toggle.classList.contains('active');
      if (!isActive) toggle.click();
      return;
    }

    if (!accordion.classList.contains('active')) {
      accordion.click();
    }
  }

  scrollIntoView(el, smooth = true) {
    el.scrollIntoView({
      block: 'start',
      inline: 'nearest',
      behavior: smooth ? 'smooth' : 'auto'
    });
  }

  getHeaderCoverHeight(extra = 8) {
    const header = document.querySelector('.header');
    const adminBar = document.getElementById('wpadminbar');

    const headerH = header ? header.getBoundingClientRect().height : 0;
    const adminH = adminBar ? adminBar.getBoundingClientRect().height : 0;

    return Math.ceil(headerH + adminH + extra);
  }

  ensureNotCoveredByHeader(target) {
    const tries = [120, 260, 420, 650];

    tries.forEach((delay) => {
      setTimeout(() => {
        const cover = this.getHeaderCoverHeight(8);
        const rect = target.getBoundingClientRect();

        if (rect.top < cover) {
          const diff = cover - rect.top;
          window.scrollBy({ top: -diff, left: 0, behavior: 'auto' });
        }
      }, delay);
    });
  }
}

export default HashHandler;
